import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/country/country.query.gql"
import type {
  CountryQuery,
  CountryQueryVariables,
} from "@/v2-backoffice-client/country/__types__/country.query"

type Options = QueryHookOptions<CountryQuery, CountryQueryVariables>

export type Country = CountryQuery["getCountries"][number]

/**
 * The countries a project or a user context may use. The catalog is small
 * and effectively static, so every picker and label on a page shares one
 * cached result rather than each fetching its own.
 */
export function useCountryQuery(options?: Options) {
  return useQuery<CountryQuery, CountryQueryVariables>(query, options)
}
